'use client'

import { useLanguage } from '@/app/LanguageContext'
import { t as translate } from './translations'

export function useT() {
  const { language } = useLanguage()

  return (key: string, vars?: Record<string, string>): string => {
    return translate(key, language, vars)
  }
}
